import React from 'react';
import Logo from './pics/Square-White-Logo-with-Cloured-Background.svg';

function ContactUs() {
    return(
        <>
            <body id="ContactUsBody" className="contact">
                <form action='/' id="contactForm" className="contact">
                    <div id="contactContainer" className="contact">
                    <div id='headerContainer'>
                        <h1 className = "header contact">Contact Us</h1> 
                        <img src={Logo} alt="logo" height={100} className="headerLogo"/>
                    </div>
                        <input type="text" placeholder='Full Name' required className="contact"></input>
                        <input type="text" name="name" placeholder='Email' required className="contact"></input>
                        <input type="text" name="name" placeholder='Phone Number' className="contact"></input>
                        <textarea placeholder='Message...' rows="5" required className="contact"></textarea>
                        <button className="button contact" type="submit" href="/">Submit</button>
                    </div>
                </form>
            </body>
        </>
    );
}
export default ContactUs;